import React from "react";

import styled from "styled-components/macro";

import { NavLink, useParams } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";

import {
  Box as MuiBox,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";

import { AgentsService } from "../../services";

const Box = styled(MuiBox)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

export const AgentThreadMessagesPage = () => {
  const [agent, setAgent] = React.useState(null);

  const [page, setPage] = React.useState(0);
  const [data, setData] = React.useState([]);

  const { agentId, threadId } = useParams();

  React.useEffect(() => {
    (async () => {
      const resAgent = await AgentsService.getById(agentId);
      setAgent(resAgent.data);
    })();
  }, [agentId]);

  React.useEffect(() => {
    (async () => {
      const resList = await AgentsService.listThreadMessages(
        agentId,
        threadId,
        page
      );
      setData(resList.data);
    })();
  }, [agentId, threadId, page]);

  return (
    <Box p={8}>
      <Helmet title="Mensagens da Conversa" />

      <Grid justify="space-between" container>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Mensagens
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/platform/agents">
              Agentes
            </Link>
            <Link
              component={NavLink}
              exact
              to={`/platform/agents/${agentId}/edit`}
            >
              {agent?.name}
            </Link>
            <Link
              component={NavLink}
              exact
              to={`/platform/agents/${agentId}/threads`}
            >
              Conversas
            </Link>
            <Typography>Mensagens</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <div>
            <Paper>
              <TableContainer>
                <Table aria-labelledby="tableTitle" size={"medium"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>PAPEL</TableCell>
                      <TableCell>TIPO</TableCell>
                      <TableCell>CONTEÚDO</TableCell>
                      <TableCell>CRIADO EM</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.rows?.map((row, index) => {
                      return (
                        <TableRow>
                          <TableCell align="left" id={index} scope="row">
                            <strong>{row.role}</strong>
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.type}
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {typeof row.content === "string"
                              ? row.content
                              : JSON.stringify(row.content)}
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.createdAt &&
                              format(
                                parseISO(row.createdAt),
                                "PPPP 'às' p",
                                {
                                  locale: pt,
                                }
                              )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                labelDisplayedRows={({ from, to, count }) =>
                  `Página ${page + 1} de ${Math.ceil(count / 6)}`
                }
                rowsPerPageOptions={[6]}
                component="div"
                count={data.count || 0}
                rowsPerPage={6}
                page={page}
                onChangePage={(_, page) => setPage(page)}
              />
            </Paper>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};
